import classNames from "classnames";
import type { BlockProps } from "./Block";
import { Block } from "./Block";

export interface SmallSquareWithBorderProps extends BlockProps {}

export const SmallSquareWithBorder = ({
  className,
  ...rest
}: SmallSquareWithBorderProps) => (
  <Block
    className={classNames(
      "border-tertiary h-4 w-4 rounded border-2",
      className,
    )}
    {...rest}
  />
);
